import React, { useMemo } from "react"

export default function JSAPreview({ activities }) {

  const tableRows = useMemo(() => {
    if (activities && activities.length) {
      let allActRows = []
      activities.forEach((activityDetails, index) => {
        const list = Array.isArray(activityDetails.fm_swms_actions_v2) ? activityDetails.fm_swms_actions_v2 : [];
        allActRows.push([<tr key={"activity_" + index}>
          <td className="font-weight-bold" style={{ backgroundColor: "#96c6e7" }}>{index + 1}</td>
          <td colSpan={7} className="font-weight-bold" style={{ backgroundColor: "#96c6e7" }} >{activityDetails.activity_name}</td>
        </tr>])
        const rows = list.flatMap((action, actionIndex) => {
          const stepLabel = `${index + 1}.${actionIndex + 1}`;
          let hazards = [];
          if (action && Array.isArray(action.fm_swms_activities_hazards_v2)) {
            hazards = action.fm_swms_activities_hazards_v2;
          }
          if (hazards.length === 0) {
            return [
              <tr key={"action-" + actionIndex + "-empty"}>
                <td rowSpan={1}>{stepLabel}</td>
                <td rowSpan={1}>{action && action.action_name != null ? action.action_name : ""}</td>
                <td></td>
                <td></td>
                <td rowSpan={1} className="text-center" style={{ background: action.irRisk }}>
                  {action && action.initial_risk != null ? action.initial_risk : ""}
                </td>
                <td rowSpan={1} style={{ whiteSpace: "pre", textWrap: "wrap" }}>
                  {action && action.control_measures != null ? action.control_measures : ""}
                </td>
                <td rowSpan={1} className="text-center" style={{ background: action.rrRisk }}>
                  {action && action.residual_risk != null ? action.residual_risk : ""}
                </td>
                <td rowSpan={1}>
                  {action && action.persons_in_control != null ? action.persons_in_control : ""}
                </td>
              </tr>
            ]
          }

          let actionRows = 0;
          const hazardRowCounts = [];

          for (let hi = 0; hi < hazards.length; hi++) {
            const hazard = hazards[hi];
            let cLen = 0;

            if (hazard && Array.isArray(hazard.fm_swms_hazards_consequences_v2)) {
              cLen = hazard.fm_swms_hazards_consequences_v2.length;
            }

            const rowsForHazard = cLen > 0 ? cLen : 1;
            hazardRowCounts.push(rowsForHazard);
            actionRows += rowsForHazard;
          }

          const output = [];
          let actionCellWritten = false;

          for (let hi2 = 0; hi2 < hazards.length; hi2++) {
            const hazard2 = hazards[hi2];

            let consequences = [];
            if (hazard2 && Array.isArray(hazard2.fm_swms_hazards_consequences_v2)) {
              consequences = hazard2.fm_swms_hazards_consequences_v2;
            }

            const rowsForHazard2 = hazardRowCounts[hi2];

            for (let ci = 0; ci < rowsForHazard2; ci++) {
              let consequenceName = "";
              if (consequences.length > 0 && ci < consequences.length) {
                const cObj = consequences[ci];
                if (cObj && cObj.consequences_name != null) {
                  consequenceName = cObj.consequences_name;
                }
              }

              const firstActionRow = !actionCellWritten;
              const firstHazardRow = ci === 0;

              output.push(
                <tr key={"a-" + actionIndex + "-h-" + hi2 + "-c-" + ci}>
                  {firstActionRow ? (
                    <td rowSpan={actionRows}>{stepLabel}</td>
                  ) : null}

                  {firstActionRow ? (
                    <td rowSpan={actionRows}>
                      {action && action.action_name ? action.action_name : ""}
                    </td>
                  ) : null}

                  {firstHazardRow ? (
                    <td onAuxClick={() => console.log("clicked", hazard2.hazard_name)} rowSpan={rowsForHazard2}>
                      {hazard2 && hazard2.hazard_name ? hazard2.hazard_name : ""}
                    </td>
                  ) : null}

                  <td>{consequenceName}</td>

                  {firstActionRow ? (
                    <td className="text-center" rowSpan={actionRows} style={{ background: action.irRisk }}>
                      {action && action.initial_risk ? action.initial_risk : ""}
                    </td>
                  ) : null}

                  {firstActionRow ? (
                    <td rowSpan={actionRows} style={{ whiteSpace: "pre", textWrap: "wrap" }}>
                      {action && action.control_measures ? action.control_measures : ""}
                    </td>
                  ) : null}

                  {firstActionRow ? (
                    <td className="text-center" rowSpan={actionRows} style={{ background: action.rrRisk }}>
                      {action && action.residual_risk ? action.residual_risk : ""}
                    </td>
                  ) : null}

                  {firstActionRow ? (
                    <td rowSpan={actionRows}>
                      {action && action.persons_in_control ? action.persons_in_control : ""}
                    </td>
                  ) : null}
                </tr>
              );
              actionCellWritten = true;
            }
          }
          return output;
        });
        allActRows.push(rows);
      });
      return allActRows;
    } else {
      return null;
    }

  }, [activities])

  return (<>
    {tableRows && tableRows.length ? tableRows.map((row, index) => (
      <React.Fragment key={index}>
        {row}
      </React.Fragment>
    )) : null}
  </>)
}